import React from "react";
import { usePermissions, useAuthenticated } from "react-admin";

// para que al loguearnos vayamos a un sitio u otro ("home" es el nombre de un recurso añadido a App.js solo para esto - el primero)

export const HomePage = ({ history }) => {
  // eslint-disable-next-line
  const { permissions } = usePermissions();

  useAuthenticated();
  // para redirigir: history.push(newLoc); (puede ser ditinto segun permissions)
  // de momento vacio - hacemos la redireccion de la misma
  return <div />;
};
